<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Priya Grewal is from Hounslow, West London, UK. She graduated from University College London with a 2.1 in BA History in 2011. Priya currently lives in Uxbridge, West London and loves reading, watching films and has a passion for writing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?56d1b49c